import { Table } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import Price from "./price";

const PriceTable = (): JSX.Element => {
  const { t } = useTranslation();
  return (
    <div className="price">
      <Table>
        <caption>
          <h4>{t("price")} </h4>
        </caption>
        <Price title="earlybird" />
        <Price title="full" />
        <Price title="deposit" />
      </Table>
    </div>
  );
};
export default PriceTable;
